module.exports = "<ngx-loading-bar></ngx-loading-bar>\n<app-messages></app-messages>\n<app-navigation></app-navigation>\n<app-breadcrumb></app-breadcrumb>\n<router-outlet></router-outlet>\n<app-menu></app-menu>"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main